module.exports = __webpack_public_path__ + "static/media/view2.9db8fc81.jpg";